// extracted by mini-css-extract-plugin
module.exports = {"messageBox":"PostCommentFormClosed-messageBox-5fe061fc56d1126b417cc4d3ebdf2714"};